export enum SuperSearchSortMethodType {
  SmartSearch = "SMART_SEARCH",
  CreationDateChronological = "CREATION_DATE_CHRONOLOGICAL",
  SlaChronological = "SLA_CHRONOLOGICAL"
}
